import CardUpImg from "../../../assets/svg/nz-bg-card-up-white.svg";
import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import AtvAccessoriesList from "../../../components/NZComponent/atvAccessories/atvAccessories";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import { useNavigate } from "react-router";
import NZAccessories from "../../../components/NZComponent/atvAccessories/NZAccessories";
import NZOtherAccessories from "../../../components/NZComponent/atvAccessories/NZOtherAccessories";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";

const AtvAccessories = () => {
  const seoData = seoConfig.nz.atvAccessories;
  let navigate = useNavigate();

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img
            src={HomeIcon}
            alt="HomeIcon"
            className="cursor-pointer"
            onClick={() => navigate("/")}
          />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] font-semibold">{`Accessories`}</div>
        </div>
        <div className="w-full bg-fixed bg-cover bg-center">
          {" "}
          <div className="w-full flex items-center justify-center">
            <div
              className="text-white kuunari-bold 
              text-[40px] 
              md:text-[80px] 
              lg:text-[120px]  py-[68px] max-w-[1127px] text-center"
              style={{
                textShadow: "2px 4px 6px #000000",
              }}
            >
              UTV ACCESSORIES
            </div>
          </div>
          <img src={CardUpImg} className="w-full" />
        </div>
        <div>
          <NZAccessories />
          <NZOtherAccessories />
          {/* <AtvAccessoriesList /> */}
        </div>

        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default AtvAccessories;
